import { createSelector } from "reselect";
import { Product, ProductsById } from "../types/product";
import { RootState } from "../reducers";

type State = RootState;

const getAllProducts = ({ productState }: State): Product[] =>
  (productState && productState.products) || [];

const generateProductsById = (products: Product[]): ProductsById =>
  products && products.length > 0
    ? products.reduce(
        (prodObj, product: Product) => ({
          ...prodObj,
          [product.id]: product,
        }),
        {},
      )
    : {};

const getAllProductsById = createSelector(getAllProducts, generateProductsById);

export { getAllProductsById };
